"use client";

import { useGlobalData } from "@/context/global-state-context";
import { LoaderCircle } from "lucide-react";

interface LoadingProps {
  progress?: number;
  buttonClicked?: boolean;
}

export default function Loading({
  progress,
  buttonClicked,
}: Readonly<LoadingProps>) {
  const { message } = useGlobalData();
  const displayProgress = progress !== undefined ? Math.max(progress, 1) : 0;

  return (
    <div className="fixed top-0 left-0 w-full h-full flex flex-col items-center justify-center bg-gray-800 bg-opacity-75 z-[10001]">
      <div className="flex flex-col items-center gap-6">
        {/* Loader with Progress Circle or Spinner */}
        {progress !== undefined && buttonClicked ? (
          <div className="relative w-48 h-48 flex items-center justify-center">
            <svg
              className="absolute w-full h-full"
              viewBox="0 0 200 200"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Background circle */}
              <circle
                cx="100"
                cy="100"
                r="90"
                stroke="#6B7280"
                strokeWidth="8"
                fill="none"
              />
              {/* Progress circle */}
              <circle
                cx="100"
                cy="100"
                r="90"
                stroke="white"
                strokeWidth="8"
                strokeDasharray={`${2 * Math.PI * 90 * (displayProgress / 100)} ${2 * Math.PI * 90}`}
                strokeLinecap="round"
                transform="rotate(-90 100 100)"
                fill="none"
                style={{ transition: "stroke-dasharray 0.3s ease" }}
              />
            </svg>
            {/* Percentage text overlay */}
            <div className="absolute flex flex-col items-center justify-center">
              <span className="text-white font-bold text-4xl">
                {displayProgress.toFixed(0)}%
              </span>
            </div>
          </div>
        ) : (
          <LoaderCircle className="w-20 h-20 animate-spin text-white" />
        )}

        {/* Message Display */}
        {message && (
          <span className="text-white font-calibri font-semibold text-base text-center max-w-sm px-4 break-words whitespace-normal">
            {message}
          </span>
        )}
      </div>
    </div>
  );
}
